import apiRequestType from "../apiRequestType";
import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";

const addTopic = (data) => {
  return apiRequestType(apiTypes.POST, apiConstants.ORGANIZE.ADD_TOPIC, data);
};

export default addTopic;
